import { useApi } from "@lending/lib/api";

/**
 * Decodes a complete 17-character VIN into year/make/model/trim through the
 * backend's NHTSA proxy.
 *
 * The response's fields are null when unknown; an all-null response means the
 * VIN had no usable match. Results go stale after a minute, mirroring the
 * backend's no-match cache TTL: a no-match or provider failure can become
 * decodable later, so it must not be pinned for the whole session. Re-fetching
 * a successful decode is cheap — the backend caches those long-term.
 */
function useDecodeVinQuery(vin: string, { enabled = true }: { enabled?: boolean } = {}) {
  const $api = useApi();

  const query = $api.useQuery(
    "get",
    "/v2/lending/car_data/decode_vin/",
    { params: { query: { vin } } },
    { enabled, retry: false, staleTime: 60 * 1000 }
  );

  return {
    decodedVehicle: query.data,
    isDecoding: query.isFetching,
    isDecodeError: query.isError,
  };
}

export { useDecodeVinQuery };
